(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[844],{

/***/ 7745:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calendar",
      function () {
        return __webpack_require__(7646);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ CalendarListEvents; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(3712);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1527);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.3_65aaefrptgalbi6a2fwpzxfmae/node_modules/next/image.js
var next_image = __webpack_require__(7659);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.3_65aaefrptgalbi6a2fwpzxfmae/node_modules/next/link.js
var next_link = __webpack_require__(5968);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(959);
;// CONCATENATED MODULE: ./components/calendar/calendarPreview.tsx




function CalendarPreview(param) {
    var title = param.title, vod = param.vod, date = param.date;
    var getVideoId = function getVideoId(vod) {
        return vod.substring(32, 43);
    };
    var ref = (0,react.useState)(false), showIframe = ref[0], setShowIframe = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-knut h-full rounded-lg bg-knut-light-bg-info transition duration-300 hover:bg-knut-light-bg dark:bg-knut-dark-bg-info hover:dark:bg-knut-dark-bg ",
        children: [
            showIframe && vod ? /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                className: "aspect-video w-full",
                src: "https://www.youtube.com/embed/".concat(getVideoId(vod), "?autoplay=1"),
                title: "YouTube video player",
                frameBorder: "0",
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                allowFullScreen: true
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                onClick: function() {
                    return setShowIframe(true);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/campknut2.webp",
                    alt: "Camp Knut",
                    height: 315,
                    width: 560,
                    decoding: "async",
                    className: "aspect-auto"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-l pt-2 pl-4 text-knut-light-header dark:text-knut-dark-header",
                children: title
            }),
            vod ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: vod,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-l pt-2 pl-4 text-knut-light-header dark:text-knut-dark-header",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: "VOD link"
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-l inline-block pt-2 pl-4 text-knut-light-header dark:text-knut-dark-header",
                        children: "No vod"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "ml-2 inline-block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/Sadge.webp",
                            alt: "Sadge",
                            width: 32,
                            height: 32,
                            decoding: "async",
                            className: "ml-4 inline-block aspect-auto"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-l pt-2 pl-4 pb-4 text-knut-light-header dark:text-knut-dark-header ",
                children: date
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/layout/PageLayout.tsx + 4 modules
var PageLayout = __webpack_require__(2582);
// EXTERNAL MODULE: ./content/links.ts
var links = __webpack_require__(2304);
// EXTERNAL MODULE: ./content/text.ts
var content_text = __webpack_require__(9862);
;// CONCATENATED MODULE: ./pages/calendar/index.tsx






var og = {
    site_name: content_text/* introduction.title */.eF.title,
    title: "Calendar - " + content_text/* introduction.title */.eF.title,
    locale: "en_GB",
    description: "Calendar for Camp Knut",
    type: "website",
    url: links/* baseUrl */.FH
};
var __N_SSG = true;
function CalendarListEvents(param) {
    var calendarEntries = param.calendarEntries;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLayout/* default */.Z, {
        widthClassName: "container flex-1 mx-auto p-4 max-w-none",
        openGraph: og,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mx-auto w-11/12",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "text-3xl pb-5 font-bold",
                    children: "Calendar"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pb-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex w-full max-w-2xl flex-row items-center gap-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative w-full"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid auto-rows-max gap-4",
                    style: {
                        gridTemplateColumns: "repeat(auto-fill,minmax(260px,1fr))"
                    },
                    children: calendarEntries.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarPreview, (0,_object_spread/* default */.Z)({}, item), item.title);
                    })
                })
            ]
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [154,555,131,774,888,179], function() { return __webpack_exec__(7745); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);